'use client';

import { createContext, useContext } from 'react';

import type { Brand } from '@/shared/config/brand';
import type { ReactNode } from 'react';

const BrandContext = createContext<Brand | null>(null);

type BrandProviderProps = {
  brand: Brand;
  children: ReactNode;
};

export function BrandProvider({ brand, children }: BrandProviderProps) {
  return <BrandContext.Provider value={brand}>{children}</BrandContext.Provider>;
}

export function useBrand(): Brand {
  const brand = useContext(BrandContext);
  if (!brand) {
    throw new Error('useBrand must be used within a BrandProvider');
  }
  return brand;
}
